export const PRODUCT_FAV_LOADING = "PRODUCT_LOADING";
export const PRODUCT_FAV_SUCCESS = "PRODUCT_SUCCESS";
export const PRODUCT_FAV_ERROR = "PRODUCT_ERROR";
